const ENERGY_LABEL_LEADS = {
  title: 'Energimerke leads',
  description: 'Oversikt over leads for energimerking',
  searchPlaceholder: 'Søk i leads …',
  emptyState: 'Ingen leads funnet.',
  importButton: 'Importer Excel',
  importError: 'Kunne ikke importere filen.',
  importEmpty: 'Filen inneholdt ingen rader.',
  importSummary: 'Importerte {imported} av {received} rader.',
  importRejected: 'Avviste rader:',
  importRow: 'Rad {row}',
  importErrors: {
    required: '{field} mangler',
    invalid: '{field} er ugyldig',
    // more precise than the generic wording, worth its own key
    organizationNumber_invalid: 'Org.nummer må ha 9 siffer',
  },
  importFields: {
    contactPerson: 'Kontaktperson',
    organizationNumber: 'Org.nummer',
    contactEmail: 'Epost',
    contactPhone: 'Mobil',
    companyName: 'Org. navn',
  },
  assignToMe: 'Tildel til meg selv',
  assignToMeNeedsEnovaGuid:
    'Brukeren din mangler Enova-GUID og kan derfor ikke ta leads.',
  backToList: 'Tilbake til leads',
  unassigned: 'Ikke tildelt',
  loadError: 'Kunne ikke hente leads.',
  assignError: 'Kunne ikke tildele leaden.',
  notFound: 'Fant ikke leaden.',
  importNotImplemented: 'Excel-import er ikke implementert enda.',
  commentSaveError: 'Kunne ikke lagre notatet.',
  commentSaved: 'Notatet er lagret.',
  daysAgo: '{count} dager siden',
  missingAddress: 'Mangler adresse',
  deleteConfirmTitle: 'Slett lead',
  deleteConfirmMessage:
    'Er du sikker på at du vil slette denne leaden? Dette kan ikke angres.',
  deleteError: 'Kunne ikke slette leaden.',
  archiveError: 'Kunne ikke arkivere leaden.',
  blockError: 'Kunne ikke blokkere leaden.',
  blockNotYours: 'Bare rådgiveren saken er tildelt kan blokkere den.',
  blockWrongStatus: 'Saken kan bare blokkeres mens befaringen pågår.',
  archiveConfirmTitle: 'Arkiver lead',
  archiveConfirmMessage:
    'Er du sikker på at du vil arkivere denne saken? Den blir satt som arkivert og forsvinner fra de åpne sakene.',
  archiveNotAllowed: 'En fullført lead kan ikke arkiveres.',
  assignWrongStatus:
    'Leaden kan bare tildeles når den har status Skjema utfylt, Tildelt rådgiver, Blokkert eller Mangler informasjon.',
  actions: {
    archive: 'Arkiver',
    block: 'Blokker',
    unblock: 'Opphev blokkering',
  },
  lifecycle: {
    title: 'Livsløp',
    steps: {
      imported: 'Lead importert',
      created: 'Opprettet — skjema sendt til kunde',
      formCompleted: 'Kunde ferdig — klar for rådgiver',
      inspectionStarted: 'Tildelt rådgiver',
      inspectionCompleted: 'Rådgiver fullført',
      completed: 'Energiattest utstedt',
    },
  },
  building: {
    title: 'Bygning',
    buildingNumber: 'Bygningsnummer',
    buildingType: 'Bygningstype',
    none: 'Ingen bygning er koblet til leaden enda.',
    open: 'Åpne bygningen',
  },
  energyLabel: {
    title: 'Energimerke',
    grade: 'Energikarakter',
    issued: 'Utstedt',
    openCertificate: 'Åpne attesten',
    complete: 'Fullfør lead',
    completeHelp:
      'Setter saken til fullført og sender energiattesten på e-post til kontaktpersonen',
    completeError: 'Kunne ikke fullføre leaden.',
  },
  inspection: {
    title: 'Befaring',
    name: 'Navn',
    date: 'Befaringsdato',
    readSubmitted: 'Les innsendt data',
    open: 'Åpne inspeksjonen',
    create: 'Opprett befaring',
    createAgain: 'Opprett ny befaring',
    noLead: 'Leaden kunne ikke lastes.',
    fixErrorsFirst: 'Rett opp de {count} feilene i kontrollene over først.',
    createHint:
      'Befaringen settes opp fra skjemaet over, med standardverdier der kunden ikke har svart.',
    created: 'Befaringen er opprettet.',
    noBuilding: 'Koble et bygg til leaden først.',
    noSubmission: 'Ingen innsendt skjema er koblet til leaden ennå.',
    createError: 'Kunne ikke opprette befaringen.',
    exists: 'En befaring for denne leaden ble nettopp opprettet.',
    filledCount: '{count} verdier ble fylt ut med standardverdier.',
  },
  filters: {
    allOpen: 'Alle åpne',
    waitingCustomer: 'Venter på kunde',
    readyForInspector: 'Klar for rådgiver',
    mine: 'Mine saker',
    completed: 'Fullført',
    stopped: 'Stoppet',
    archived: 'Arkiverte',
  },
  columns: {
    contactPerson: 'Kontaktperson',
    organizationNumber: 'Organisasjonsnummer',
    address: 'Adresse',
    status: 'Status',
    consultant: 'Rådgiver',
    created: 'Opprettet',
    actions: 'Handling',
  },
  reminder: {
    send: 'Send påminnelse',
    sent: 'Påminnelse sendt',
    help: 'Sender skjemalenken på nytt med samme frist',
    noDeadline: 'Leaden har ingen frist ennå — send første varsel først',
    error: 'Kunne ikke sende påminnelsen.',
  },
  status: {
    imported: 'Importert',
    created: 'Opprettet',
    formCompleted: 'Skjema utfylt',
    inspectionStarted: 'Tildelt rådgiver',
    inspectionCompleted: 'Befaring gjennomført',
    completed: 'Energimerke utstedt',
    blocked: 'Blokkert',
    notEnoughInformation: 'Mangler informasjon',
    cancelled: 'Arkivert',
    unknown: 'Ukjent',
  },
  detail: {
    companyName: 'Firmanavn',
    internalComment: 'Internt notat',
    internalCommentPlaceholder: 'Kun synlig for oss, aldri for kunden',
    contactSection: 'Kontaktinformasjon',
    contactPerson: 'Kontaktperson',
    phone: 'Telefon',
    email: 'E-post',
    companySection: 'Virksomhet',
    organizationNumber: 'Organisasjonsnummer',
    streetName: 'Gatenavn',
    houseNumber: 'Husnummer',
    houseLetter: 'Bokstav',
    postalCode: 'Postnummer',
    city: 'Sted',
    mpidsSection: 'Målepunkt-IDer',
    noMpids: 'Ingen målepunkt-IDer registrert',
    status: 'Status',
    formSection: 'Kundeskjema',
    formLink: 'Lenke til kunden',
    copyLink: 'Kopier lenke',
    linkCopied: 'Lenken er kopiert.',
    formStatus: 'Skjemastatus',
    formNotStarted: 'Ikke åpnet ennå',
    formDraft: 'Under utfylling',
    formSubmitted: 'Sendt inn',
  },
  submissionView: {
    title: 'Innsendt skjema',
    open: 'Les innsendt data',
    draft: 'Utkast',
    backToLead: 'Tilbake til leaden',
    notStarted: 'Kunden har ikke begynt på skjemaet ennå.',
    loadError: 'Kunne ikke hente skjemaet.',
    item: 'Anlegg {number}',
    inactive: 'ikke i bruk',
    hiddenRows: '{count} felt er ikke aktuelle og står tomme',
    notApplicableEmpty: 'Ikke aktuelt for dette bygget. Ingen verdier oppgitt.',
    status: {
      DRAFT: 'Utkast',
      SUBMITTED: 'Sendt inn',
      IN_REVIEW: 'Under vurdering',
      COMPLETED: 'Fullført',
    },
    meta: {
      started: 'Startet',
      lastSaved: 'Sist lagret',
      submitted: 'Sendt inn',
    },
    fields: {
      street: 'Adresse',
      postalCode: 'Postnummer',
      city: 'Sted',
      gnr: 'Gårdsnummer',
      bnr: 'Bruksnummer',
      latitude: 'Breddegrad',
      longitude: 'Lengdegrad',
      confirmedByCustomer: 'Bygget bekreftet av kunden',
      buildingNumber: 'Bygningsnummer',
      registryType: 'Bygningstype i matrikkelen',
      districtUseUnknown: 'Vet ikke hva fjernvarmen brukes til',
      goodFaith: 'Bekreftet i god tro',
      termsAccepted: 'Vilkår godtatt',
      confirmedAt: 'Bekreftet',
      respondentEmail: 'E-post til den som svarte',
      knowsBuilding: 'Kjenner bygget teknisk',
      dataQuality: 'Datakvalitet',
      completeness: 'Utfylt',
      anySource: 'Minst én energikilde valgt',
      anyHeating: 'Minst én oppvarmingsløsning valgt',
      category: 'Bygningskategori',
      buildYear: 'Byggeår',
      floors: 'Antall etasjer',
    },
    tiers: {
      required: 'Påkrevd',
      important: 'Viktig',
      missing: 'Mangler',
      defaults: 'Standardverdi',
      notApplicable: 'Ikke aktuelt',
      complete: 'Komplett',
    },
    readiness: {
      title: 'Datagrunnlag for befaring',
      ready: 'Alle påkrevde felt er fylt inn',
      notReady: '{count} påkrevde felt er ikke fylt inn',
      coverage: 'Datadekning',
      required: 'Påkrevd',
      important: 'Viktig for beregningen',
      windowShare: 'Vindusandel av oppvarmet areal',
      mismatches: 'Avvik mot lead',
      missingRequired: 'Påkrevde felt kunden ikke har fylt inn',
      missingImportant: 'Mangler, beregnes med standardverdier',
      nothingMissing: 'Ingenting mangler.',
    },
    advisor: {
      title: 'Melding til energirådgiver',
      count: '{count} fra kunden',
    },
    checks: {
      title: 'Kontroller',
      none: 'Svarene henger sammen.',
      allGood: 'Ingen funn',
      stepCount: '{count} å sjekke',
      severity: { error: 'Feil', warning: 'Sjekk', info: 'Merknad' },
      counts: {
        error: '{count} feil',
        warning: '{count} å sjekke',
        info: '{count} merknader',
      },
      messages: {
        outsideNorway: 'Koordinatene ligger utenfor Norge.',
        farFromRegistryPoint:
          'Punktet ligger {metres} m fra byggets punkt i matrikkelen.',
        locationNotConfirmed:
          'Kunden har ikke bekreftet plasseringen på kartet.',
        registry: {
          details:
            'Detaljene fra matrikkelen kunne ikke hentes. Areal og etasjer er ikke kontrollert mot registeret.',
          notFound: 'Bygget ble ikke funnet i matrikkelen.',
          upstream: 'Matrikkelen svarte ikke da bygget ble slått opp.',
          timeout: 'Oppslaget i matrikkelen tok for lang tid.',
        },
        registryAddressMismatch:
          'Adressen i matrikkelen er en annen enn den kunden valgte.',
        categoryDiffersFromRegistry:
          'Kategorien er en annen enn bygningstypen i matrikkelen tilsvarer.',
        subcategoryDiffersFromRegistry:
          'Underkategorien er en annen enn matrikkelen tilsier.',
        areaDiffersFromRegistry:
          'Avviker {percent} % fra bruksarealet i matrikkelen ({registry} m²).',
        floorsDifferFromRegistry:
          'Matrikkelen har {registry} etasjer registrert.',
        prefilledEstimate:
          'Forhåndsutfylt som et estimat fra kartet, ikke målt eller oppgitt.',
        prefilledDefault: 'Forhåndsutfylt med en standardverdi.',
        yearInFuture: 'Året ligger fram i tid.',
        noBuildYear:
          'Byggeår mangler. Befaringen kan ikke dimensjonere oppvarmingen (den blir 0 kW) eller fylle inn U-verdier, luftlekkasje, g-verdier for vinduer og ventilasjon fra standardverdier. Legg inn byggeåret før befaringen opprettes.',
        buildYearVeryOld:
          'Byggeår før 1800. Sjekk at det ikke er en skrivefeil.',
        heatedAboveUsable:
          'Oppvarmet areal ({heated} m²) er større enn bruksarealet ({usable} m²).',
        heatedMuchBelowUsable: 'Bare {percent} % av bruksarealet er oppvarmet.',
        usableAboveFootprintTimesFloors:
          'Bruksarealet er større enn grunnflate × etasjer ({max} m²).',
        usableBelowFootprint:
          'Bruksarealet er under halvparten av grunnflaten ({footprint} m²).',
        manyFloors: 'Over 40 etasjer. Sjekk at det ikke er en skrivefeil.',
        floorHeightUnusual: 'Etasjehøyden er utenfor det vanlige (2,2–6 m).',
        insulationUnusual: 'Isolasjonen er tykkere enn 500 mm.',
        windowsAboveHeatedArea:
          'Vindusarealet er større enn hele det oppvarmede arealet ({share} %).',
        windowShareAboveTek17:
          'Vinduene utgjør {share} % av oppvarmet areal. TEK17 tillater maks {max} %.',
        orientationSumDiffers:
          'Summen per fasade ({sum} m²) stemmer ikke med totalen ({total} m²).',
        installedBeforeBuilt:
          'Installert {year}, før bygget sto ferdig ({buildYear}).',
        annualUseAboveFullPower:
          'Årlig bruk er mer enn full effekt hele året gir ({max} kWh).',
        powerHighForArea:
          'Effekten tilsvarer {wPerM2} W per m² oppvarmet areal, som er høyt.',
        solarYieldUnusual:
          'Gir {yield} kWh per kWp i året. Vanlig i Norge er 600–1100.',
        solarDensityUnusual:
          '{kwpPerM2} kWp per m² panel. Vanlig er 0,15–0,23.',
        sharesNotHundred: 'Andelene summerer til {sum} %, ikke 100 %.',
        centralWithoutSource:
          'Vannbåren varme er valgt, men ingen energikilde kan varme vannet.',
        districtWithoutDistribution:
          'Fjernvarme er valgt, men ingen vannbåren varme i bygget.',
        systemCountDiffers: 'Oppgitt {count} anlegg, men {found} er fylt inn.',
        recoveryOnExhaustOnly:
          'Mekanisk avtrekk har vanligvis ikke varmegjenvinning.',
        recoveryVeryHigh: 'Varmegjenvinning over 90 % er uvanlig høyt.',
        offAboveOperating:
          'Luftmengden utenfor driftstid er større enn i driftstid.',
        airflowUnusual: '{perM2} m³/h per m² er utenfor det vanlige (0,3–20).',
      },
    },
    comparison: {
      title: 'Lead mot skjema',
      lead: 'Lead og bygg',
      form: 'Skjema',
      allMatch: 'Ingen avvik',
      mismatchCount: '{count} avvik',
      status: {
        match: 'Samsvar',
        mismatch: 'Avvik',
        missingLead: 'Kun i skjema',
        missingForm: 'Mangler i skjema',
      },
    },
  },
  loginLog: {
    title: 'Innloggingslogg',
    description:
      'Hvert steg når kunden logger inn på skjemaet med SMS-kode. Slettes automatisk etter 90 dager.',
    empty: 'Ingen har prøvd å logge inn på denne leaden ennå.',
    loadError: 'Kunne ikke hente innloggingsloggen.',
    refresh: 'Oppdater',
    columns: {
      time: 'Tidspunkt',
      step: 'Steg',
      outcome: 'Resultat',
      phone: 'Telefon',
      ip: 'IP-adresse',
    },
    steps: {
      requestCode: 'Ba om kode',
      verify: 'Skrev inn kode',
      logout: 'Logget ut',
    },
    outcomes: {
      sent: 'SMS sendt',
      cooldown: 'Ikke sendt, ba om ny kode for raskt',
      smsFailed: 'SMS feilet',
      invalidPhone: 'Ugyldig telefonnummer',
      unknownLead: 'Ukjent lead',
      closedLead: 'Leaden er lukket',
      noBuilding: 'Leaden mangler bygg',
      invalidFormat: 'Koden var ikke seks siffer',
      wrongCode: 'Feil kode',
      codeExpired: 'Koden var utløpt',
      tooManyAttempts: 'For mange forsøk',
      noCode: 'Ingen aktiv kode',
      buildingIncomplete: 'Bygget mangler data til skjemaet',
      success: 'Logget inn',
    },
    attemptsLeft: '{count} forsøk igjen',
  },
};

export default ENERGY_LABEL_LEADS;
